import React, { useCallback, useEffect, useState } from 'react';

import { TableRow, TableCell, TableSortLabel } from '@material-ui/core';

import {
  findLastIndex,
  isUndefined,
  findIndex,
  isEmpty,
  trim,
  includes,
  remove,
  isNumber,
} from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

import { convertType } from '~/helpers';

import * as S from './styles';

import { InputMaterialUI, DateTimeGrid } from '..';

export default function Theader({
  headers,
  orderBy,
  order,
  createSortHandler,
  filters,
  fields,
}) {
  const [testeFields, setTesteFields] = useState([]);
  const [sendKey, setSendKey] = useState('');
  const [queryTemp, setQueryTemp] = useState({
    wherefield: [],
    valuewherefield: [],
    typewherefield: [],
  });
  const [parameters, setParameters] = useState({
    wherefield: [],
    valuewherefield: [],
    typewherefield: [],
  });

  // Check active header
  const activated = React.useMemo(() => {
    return findLastIndex(headers, (header) => !isUndefined(header.filter));
  }, [headers]);

  // Submit parameters
  const handleSendParameters = React.useCallback((id, type, value) => {
    setTesteFields((old) => [
      ...remove(old, (item) => item.id != id),
      { id, value, type },
    ]);
  }, []);



  // Order fields
  const handleOrder = React.useCallback(
    ({ id }) => {
      const ordering = orderBy === id && order === 'asc' ? 'desc' : 'asc';
      const objectFields = {
        wherefield: [],
        valuewherefield: [],
        typewherefield: [],
        typeField: [],
      };

      testeFields.forEach((item) => {
        if (!isEmpty(trim(item.value)) || isNumber(item.value)) {
          objectFields.wherefield.push(item.id);
          objectFields.valuewherefield.push(item.value);
          objectFields.typewherefield.push(convertType(item.type));
          objectFields.typeField.push(item.type)
        }
      });

      if (isEmpty(objectFields.wherefield)) createSortHandler(id, ordering, {});
      else createSortHandler(id, ordering, objectFields);
    },
    [testeFields, order, orderBy]
  );

  const handleChangeVarsTemp = React.useCallback(
    (id, type, value) => {
      if (!includes(['select'], type)) {
        const { wherefield } = queryTemp;
        const { typewherefield } = queryTemp;
        const { valuewherefield } = queryTemp;

        const index = findIndex(wherefield, (where) => where === id);

        if (index < 0) {
          wherefield.push(id);
          typewherefield.push(convertType(type));
          valuewherefield.push(value);
        } else {
          valuewherefield.splice(index, 1, value);

          if (isEmpty(trim(value))) {
            wherefield.splice(index, 1);
            valuewherefield.splice(index, 1);
            typewherefield.splice(index, 1);
          }
        }

        setQueryTemp({ wherefield, typewherefield, valuewherefield });
      }
    },
    [queryTemp]
  );

  // Render Input
  const handleRenderInput = React.useCallback(({ id, filter }) => {
    const { type, options, defaultValue } = filter || {};

    // Check exists filter
    if (isUndefined(filter)) return <S.Wrapper />;

    switch (type) {
      case 'text':
      case 'number':
      case 'date':
      case 'time':
      case 'select':
      case 'initialtime':
      case 'finaltime':
      default:
        return (
          <InputMaterialUI
            id={id}
            type={type}
            initials={defaultValue}
            onSubmit={handleSendParameters}
            options={options}
            onGetValueTemp={handleChangeVarsTemp}
            keySubmit={(key) => setSendKey(key)}
          />
        );
      case 'datetime':
      case 'initialdatetime':
      case 'finaldatetime':
        return (
          <DateTimeGrid
            time
            id={id}
            type={type}
            initials={defaultValue}
            onSubmit={handleSendParameters}
            keySubmit={(key) => setSendKey(key)}
          />

        );
    }
  }, []);

  // Filter initial
  useEffect(() => {
    const typewherefield = [];
    const wherefield = [];
    const valuewherefield = [];
    const typeField = []

    // Search input set default value
    const searchInputs = headers.filter(
      ({ filter }) => !isUndefined(filter) && !isUndefined(filter.defaultValue)
    );

    searchInputs.map(({ id, filter }) => {
      const { type, defaultValue } = filter;
      const inputDT = includes(['initialdatetime', 'finaldatetime'], type);

      let modifyValueInDateTime = defaultValue;

      if (!isEmpty(trim(defaultValue)) && inputDT) {
        const dateTime = moment(defaultValue);

        if (type === 'initialdatetime') dateTime.set({ second: 0 });
        else dateTime.set({ second: 59 });

        modifyValueInDateTime = dateTime.format('DD/MM/YYYY HH:mm:ss');
      }

      typewherefield.push(convertType(type));
      wherefield.push(id);
      valuewherefield.push(modifyValueInDateTime);
      typeField.push(type)
    });

    // Object using to save in state
    const objectParameters = {
      wherefield,
      valuewherefield,
      typewherefield,
      typeField
    };

    if (isEmpty(parameters.typewherefield)) {
      setParameters(objectParameters);
      filters(objectParameters);

    }
  }, []);

  useEffect(() => {
    if (!isEmpty(fields)) {
      setTesteFields(fields);
    }
  }, [fields]);

  useEffect(() => {
    if (sendKey === 'Enter') {
      const objectFields = {
        wherefield: [],
        valuewherefield: [],
        typewherefield: [],
        typeField: []
      };

      testeFields.forEach((item) => {
        if (!isEmpty(trim(item.value)) || isNumber(item.value)) {
          objectFields.wherefield.push(item.id);
          objectFields.valuewherefield.push(item.value);
          objectFields.typewherefield.push(convertType(item.type));
          objectFields.typeField.push(item.type)
        }
      });
      filters(objectFields)
      setSendKey('');
      // if (isEmpty(objectFields.wherefield)) filters();
      // else filters(objectFields);

      
    }
  }, [testeFields, sendKey]);



  return (
    <TableRow>
      {headers.map((header) => (
        <TableCell
          key={header.id}
          sortDirection={orderBy === header.id ? order : false}
          style={activated >= 0 ? { paddingBottom: 0 } : {}}
        >
          <TableSortLabel
            active={orderBy === header.id}
            direction={orderBy === header.id ? order : 'asc'}
            onClick={() => handleOrder(header)}
            style={{ whiteSpace: 'nowrap' }}
          >
            {header.label}
          </TableSortLabel>
          {activated >= 0 && handleRenderInput(header)}
        </TableCell>
      ))}
    </TableRow>
  );
}

Theader.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.any).isRequired,
  orderBy: PropTypes.string,
  order: PropTypes.oneOf(['asc', 'desc']),
  createSortHandler: PropTypes.func.isRequired,
  filters: PropTypes.func.isRequired,
};

Theader.defaultProps = {
  orderBy: '',
  order: 'asc',
};
